import React from "react";

const NavItemTemplate = ({
  handleClick,
  handleExpandClick,
  active,
  title,
  icon,
  buttonExpand,
  children,
  menuItemMainClass,
  disabled
}) => {
  const handleArrowClick = (e) => {
    e.stopPropagation();
    if (handleExpandClick) {
      handleExpandClick();
    }
  };

  return (
    <div className="menu-item">
      <div
        className={`menu-item-main ${menuItemMainClass || ""} ${
          active ? "active" : ""
        }`}
        onClick={() => handleClick()}
        style={disabled ? {cursor: "progress"} : {}}
      >
        <div className="icon">{icon}</div>
        <span className="text text-truncate ps-3">{title}</span>
        {buttonExpand && (
          <span 
            className="expand-button" 
            onClick={handleArrowClick}
            style={{ cursor: "pointer" }}
          >
            {buttonExpand}
          </span>
        )}
      </div>
      {children}
    </div>
  );
};

export default NavItemTemplate;
